/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TChatsBulkOperationsDeleteAllFromSectionDesktopModel = IModel<
  IChatsBulkOperationsDeleteAllFromSectionDesktopRequest,
  TChatsBulkOperationsDeleteAllFromSectionDesktopResponse
>;

export interface IChatsBulkOperationsDeleteAllFromSectionDesktopRequest {
  section: ESection;
}

export type TChatsBulkOperationsDeleteAllFromSectionDesktopResponse =
  | IChatsBulkOperationsDeleteAllFromSectionDesktopResponse200
  | IChatsBulkOperationsDeleteAllFromSectionDesktopResponse400;

export interface IChatsBulkOperationsDeleteAllFromSectionDesktopResponse200
  extends IModelResponse<IChatsBulkOperationsDeleteAllFromSectionDesktopResponse> {
  statusCode: 200;
}

export interface IChatsBulkOperationsDeleteAllFromSectionDesktopResponse400
  extends IModelResponse<IChatsBulkOperationsDeleteAllFromSectionDesktopResponseError> {
  statusCode: 400;
}

export interface IChatsBulkOperationsDeleteAllFromSectionDesktopResponse {}

export interface IChatsBulkOperationsDeleteAllFromSectionDesktopResponseError {
  errors: any[];
  message: string;
}

export type TResponses =
  | IChatsBulkOperationsDeleteAllFromSectionDesktopResponse
  | IChatsBulkOperationsDeleteAllFromSectionDesktopResponseError;

export enum ESection {
  /** Раздел "Архив" **/
  Archive = 'archive',
  /** Раздел "Сообщения" **/
  Main = 'main',
  /** Раздел "Непрочитанные" **/
  Unread = 'unread',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IChatsBulkOperationsDeleteAllFromSectionDesktopResponse): TResponse200;
  400(response: IChatsBulkOperationsDeleteAllFromSectionDesktopResponseError): TResponse400;
}
